module.exports = __webpack_public_path__ + "static/media/Preyana_Logo.872f3e7d.svg";